import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  :root {
    /* Primary */
    --color-primary: ${({ theme }) => theme.colors.primary};
    --color-primary-hover: ${({ theme }) => theme.colors.primaryHover};
    --color-primary-active: ${({ theme }) => theme.colors.primaryActive};
    --color-primary-light: ${({ theme }) => theme.colors.primaryLight};
    --color-primary-dark: ${({ theme }) => theme.colors.primaryDark};

    /* Background */
    --color-background: ${({ theme }) => theme.colors.background};
    --color-background-secondary: ${({ theme }) => theme.colors.backgroundSecondary};
    --color-background-tertiary: ${({ theme }) => theme.colors.backgroundTertiary};
    --color-background-hover: ${({ theme }) => theme.colors.backgroundHover};

    /* Surface */
    --color-surface: ${({ theme }) => theme.colors.surface};
    --color-surface-hover: ${({ theme }) => theme.colors.surfaceHover};
    --color-surface-border: ${({ theme }) => theme.colors.surfaceBorder};

    /* Text */
    --color-text: ${({ theme }) => theme.colors.text};
    --color-text-secondary: ${({ theme }) => theme.colors.textSecondary};
    --color-text-tertiary: ${({ theme }) => theme.colors.textTertiary};
    --color-text-inverse: ${({ theme }) => theme.colors.textInverse};
    --color-text-disabled: ${({ theme }) => theme.colors.textDisabled};

    /* Success */
    --color-success: ${({ theme }) => theme.colors.success};
    --color-success-bg: ${({ theme }) => theme.colors.successBg};
    --color-success-hover: ${({ theme }) => theme.colors.successHover};
    --color-success-light: ${({ theme }) => theme.colors.successLight};
    --color-success-lighter: ${({ theme }) => theme.colors.successLighter};
    --color-success-dark: ${({ theme }) => theme.colors.successDark};

    /* Error */
    --color-error: ${({ theme }) => theme.colors.error};
    --color-error-bg: ${({ theme }) => theme.colors.errorBg};
    --color-error-hover: ${({ theme }) => theme.colors.errorHover};
    --color-error-light: ${({ theme }) => theme.colors.errorLight};
    --color-error-lighter: ${({ theme }) => theme.colors.errorLighter};
    --color-error-dark: ${({ theme }) => theme.colors.errorDark};
    --color-error-border: ${({ theme }) => theme.colors.errorBorder};

    /* Warning */
    --color-warning: ${({ theme }) => theme.colors.warning};
    --color-warning-bg: ${({ theme }) => theme.colors.warningBg};
    --color-warning-hover: ${({ theme }) => theme.colors.warningHover};
    --color-warning-light: ${({ theme }) => theme.colors.warningLight};
    --color-warning-dark: ${({ theme }) => theme.colors.warningDark};

    /* Info */
    --color-info: ${({ theme }) => theme.colors.info};
    --color-info-bg: ${({ theme }) => theme.colors.infoBg};
    --color-info-light: ${({ theme }) => theme.colors.infoLight};
    --color-info-dark: ${({ theme }) => theme.colors.infoDark};

    /* Gradient */
    --gradient-primary: linear-gradient(135deg, ${({ theme }) => theme.colors.gradientStart} 0%, ${({ theme }) => theme.colors.gradientEnd} 100%);
    --gradient-start: ${({ theme }) => theme.colors.gradientStart};
    --gradient-end: ${({ theme }) => theme.colors.gradientEnd};

    /* Shadow */
    --color-shadow: ${({ theme }) => theme.colors.shadow};
    --color-shadow-light: ${({ theme }) => theme.colors.shadowLight};

    /* Border */
    --color-border: ${({ theme }) => theme.colors.border};
    --color-border-light: ${({ theme }) => theme.colors.borderLight};
    --color-border-dark: ${({ theme }) => theme.colors.borderDark};
    --color-border-input: ${({ theme }) => theme.colors.borderInput};
    --color-border-hover: ${({ theme }) => theme.colors.borderHover};
    --color-divider: ${({ theme }) => theme.colors.divider};

    /* Overlay */
    --color-overlay: ${({ theme }) => theme.colors.overlay};
    --color-overlay-dark: ${({ theme }) => theme.colors.overlayDark};

    /* Gray scale */
    --color-gray-50: ${({ theme }) => theme.colors.gray50};
    --color-gray-100: ${({ theme }) => theme.colors.gray100};
    --color-gray-200: ${({ theme }) => theme.colors.gray200};
    --color-gray-300: ${({ theme }) => theme.colors.gray300};
    --color-gray-400: ${({ theme }) => theme.colors.gray400};
    --color-gray-500: ${({ theme }) => theme.colors.gray500};
    --color-gray-600: ${({ theme }) => theme.colors.gray600};
    --color-gray-700: ${({ theme }) => theme.colors.gray700};
    --color-gray-800: ${({ theme }) => theme.colors.gray800};
    --color-gray-900: ${({ theme }) => theme.colors.gray900};

    /* Input */
    --color-input-disabled: ${({ theme }) => theme.colors.inputDisabled};
  }

  body {
    background-color: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.text};
    transition: background-color 0.2s ease, color 0.2s ease;
  }

  /* Nadpisania dla Ant Design w dark mode */
  html.dark {
    .ant-notification-notice {
      background: var(--color-surface) !important;
      color: var(--color-text) !important;

      .ant-notification-notice-message {
        color: var(--color-text) !important;
      }

      .ant-notification-notice-description {
        color: var(--color-text-secondary) !important;
      }

      .ant-notification-notice-close {
        color: var(--color-text-tertiary) !important;
      }
    }

    .ant-message-notice-content {
      background: var(--color-surface) !important;
      color: var(--color-text) !important;
    }

    .ant-message .ant-message-notice .ant-message-notice-content {
      background: var(--color-surface) !important;
      color: var(--color-text) !important;
    }

    .ant-message-custom-content span,
    .ant-message-custom-content .anticon + span {
      color: var(--color-text) !important;
    }

    .ant-dropdown-menu {
      background: var(--color-surface) !important;
    }

    .ant-popover-inner {
      background: var(--color-surface) !important;
    }

    .ant-select-dropdown {
      background: var(--color-surface) !important;
    }

    .ant-picker-dropdown {
      .ant-picker-panel-container {
        background: var(--color-surface) !important;
      }
    }
  }

  /* Wymuszenie top: 20px dla wszystkich modali na desktopie/tablecie */
  @media (min-width: 768px) {
    .ant-modal {
      top: 20px !important;
    }
  }
`;
